// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import type { JSX } from 'react';
import { ClaimsList } from '../../components/claims/ClaimsList';

export function ClaimsTab(): JSX.Element {
  return <ClaimsList />;
}
